import { Box, styled } from '@mui/material';

export const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));